import produce from 'immer';
import { Actions } from './action';
import { AppAction } from './enum';
import { AppState } from './interface';

export const initialState: AppState = {
    loadingStatus: {},
    selectedTariffId: 'DSL-IP-250000-TW',
    tariffs: {},
};

const appReducer = (state: AppState = initialState, action: Actions) =>
    produce(state, draft => {
        switch (action.type) {
            case AppAction.InitStore:
                draft.selectedTariffId = action.state.selectedTariffId ?? draft.selectedTariffId;
                draft.tariffs = action.state.tariffs ?? {};
                draft.customer = action.state.customer;
                break;
            case AppAction.SetLoading:
                action.isLoading
                    ? draft.loadingStatus[action.id] = true
                    : delete draft.loadingStatus[action.id];
                break;
            case AppAction.SetError:
                draft.error = action.error;
                break;
            case AppAction.SetSelectedTariffId:
                draft.selectedTariffId = action.selectedTariffId;
                break;
            case AppAction.SetTariffs:
                draft.tariffs = action.tariffs;
                break;
            case AppAction.SetCustomer:
                draft.customer = action.customer;
                break;
        }
    });

export default appReducer;
